import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1rem;

  @media (max-width: 1020px) {
    grid-template-columns: 1fr;
  }
`
